import React, { Component } from "react";
import { BsArrowLeftCircleFill } from "react-icons/bs";
import AuthService from "../session/AuthService";
import { withRouter } from "react-router";
import { connect } from "react-redux";

class NavigationChange extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    console.log("this.props.back::::",this.props.back)
    return (
      <>
        <div class="task-container">
         {AuthService.getUserTypeAdmin() === "3"  && this.props.back && (
           <span className="cursor-pointer">
           <BsArrowLeftCircleFill style={{ color: "#00000", fontSize: "30px" }}  onClick={this.backToForm}/>
              </span>
         )} 
           <span style={{fontWeight : "bolder" , fontSize : "25px"}}>{this.props.Topics}</span>
              
          {this.props.Topics !== "Services Records"  && (
  <span style={{ fontWeight: "bolder" , fontSize : "20px" }}>{this.props.numberofRecord} Records <span className="text-danger">{this.props?.totalExpired && this.props?.totalExpired !== 0 ? ` (${this.props?.totalExpired} Expired)` :""}</span></span>
)}
      
        
        </div>
       
      </>
    );
  }

  backToForm = () => {

    this.props.history.replace("/Employers");

  }

}

const mapStateToProps = function (state) {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(NavigationChange));

